// src/services/auth.js


class AuthService {
  constructor() {
    this.token = localStorage.getItem('token');
    this.user = JSON.parse(localStorage.getItem('user') || 'null');
  }

  async login(email, password) {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || '/api'}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        this.setAuthData(data.token, data.user);
        return { success: true, user: data.user };
      } else {
        return { success: false, error: data.error || 'Credenciales incorrectas' };
      }
    } catch (error) {
      return { success: false, error: 'Error de conexión' };
    }
  }
   // Gestión de usuarios (solo admin)
  async getUsers() {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || '/api'}/users`, {
        headers: this.getAuthHeaders(),
      });

      const data = await response.json();
      
      if (response.ok) {
        return { success: true, users: data };
      } else {
        return { success: false, error: data.error || 'Error al obtener usuarios' };
      }
    } catch (error) {
      return { success: false, error: 'Error de conexión' };
    }
  }

  async createUser(userData) {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || '/api'}/users`, {
        method: 'POST',
        headers: this.getAuthHeaders(),
        body: JSON.stringify(userData),
      });

      const data = await response.json();
      
      if (response.ok) {
        return { success: true, user: data.user, message: data.message };
      } else {
        return { success: false, error: data.error || 'Error al crear usuario' };
      }
    } catch (error) {
      return { success: false, error: 'Error de conexión' };
    }
  }

  async updateUser(id, userData) {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || '/api'}/users/${id}`, {
        method: 'PUT',
        headers: this.getAuthHeaders(),
        body: JSON.stringify(userData),
      });

      const data = await response.json();
      
      if (response.ok) {
        return { success: true, user: data.user, message: data.message };
      } else {
        return { success: false, error: data.error || 'Error al actualizar usuario' };
      }
    } catch (error) {
      return { success: false, error: 'Error de conexión' };
    }
  }

  async deactivateUser(id) {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || '/api'}/users/${id}`, {
        method: 'DELETE',
        headers: this.getAuthHeaders(),
      });

      const data = await response.json();
      
      if (response.ok) {
        return { success: true, message: data.message };
      } else {
        return { success: false, error: data.error || 'Error al desactivar usuario' };
      }
    } catch (error) {
      return { success: false, error: 'Error de conexión' };
    }
  }

  async reactivateUser(id) {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || '/api'}/users/${id}/reactivate`, {
        method: 'POST',
        headers: this.getAuthHeaders(),
      });

      const data = await response.json();
      
      if (response.ok) {
        return { success: true, message: data.message };
      } else {
        return { success: false, error: data.error || 'Error al reactivar usuario' };
      }
    } catch (error) {
      return { success: false, error: 'Error de conexión' };
    }
  }

  async logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    this.token = null;
    this.user = null;
    window.location.href = '/admin';
  }

  setAuthData(token, user) {
    this.token = token;
    this.user = user;
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
  }

  isAuthenticated() {
    return !!this.token && !!this.user;
  }

  getUser() {
    return this.user;
  }

  getToken() {
    return this.token;
  }

  async checkAuth() {
    if (!this.token) {
      return false;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || '/api'}/auth/verify`, {
        headers: {
          'Authorization': `Bearer ${this.token}`,
        },
      });

      const data = await response.json();

      if (response.ok && data.valid) {
        return true;
      } else {
        this.logout();
        return false;
      }
    } catch (error) {
      console.error('Error verificando autenticación:', error);
      return false;
    }
  }

  // Headers para requests autenticados
  getAuthHeaders() {
    return {
      'Authorization': `Bearer ${this.token}`,
      'Content-Type': 'application/json',
    };
  }

  getAuthHeadersForFormData() {
    return {
      'Authorization': `Bearer ${this.token}`,
    };
  }
}

export const authService = new AuthService();